export default "__VITE_ASSET__DPEOkLbb__"